import { RigidBodyConstructionInfoList } from "../rigidBodyConstructionInfoList";
export class PluginConstructionInfoList extends RigidBodyConstructionInfoList {
    worldId;
    commandsOnCreation;
    constructor(wasmInstance, count) {
        super(wasmInstance, count);
        this.worldId = 0;
        this.commandsOnCreation = [];
    }
    get length() {
        return this.count;
    }
}
